import React from 'react';
import { FieldProps } from 'formik';
import { Input } from '../ui/Input';
import { cn } from '../../utils/cn';

interface InputFieldOwnProps {
  label?: string;
  limit?: number;
  disabled?: boolean;
  placeholder?: string;
  type?: string;
  className?: string;
  required?: boolean;
}

type InputFieldProps = FieldProps & InputFieldOwnProps;

export const InputField: React.FC<InputFieldProps> = ({
  field,
  form: { touched, errors, submitCount },
  label,
  limit,
  disabled,
  placeholder,
  type = 'text',
  className,
  required,
}) => {
  const hasError =
    (touched[field.name] && !!errors[field.name]) || (!!errors[field.name] && submitCount > 0);
  const errorMsg = hasError ? (errors[field.name] as string) : null;

  return (
    <div className={cn('flex flex-col gap-1', className)}>
      {label && (
        <label htmlFor={field.name} className="text-sm font-medium text-neutral-700">
          {label}
          {required && <span className="text-destructive ml-0.5">*</span>}
        </label>
      )}
      <Input
        id={field.name}
        data-testid={`input-field-${field.name}`}
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        maxLength={limit}
        aria-invalid={hasError}
        className={cn(hasError && 'border-red-500 focus-visible:ring-red-500')}
        {...field}
      />
      {hasError && <span className="text-destructive text-xs">{errorMsg}</span>}
    </div>
  );
};
